import Cocoen from 'cocoen'
import $ from 'jquery';

$('.cocoen').each(function (i, div) {
    new Cocoen(div);
});
